import { useAppDispatch, useAppSelector } from "@/config/store";
import { Button } from "@/components/ui";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui";
import { IEdoChapter } from "@/shared/model/edo-chapter.model";
import { useEffect } from "react";
import { Translate } from "react-jhipster";
import { deleteEntity } from "../../../../shared/reducers/entities/edo-chapter.reducer";

interface IDeleteChapterProps {
  chapter: IEdoChapter;
  open: boolean;
  onClose: () => void;
}

const DeleteChapter = (props: IDeleteChapterProps) => {
  const dispatch = useAppDispatch();
  const updateSuccess = useAppSelector<boolean>(
    (state) => state.edoChapter.updateSuccess
  );

  const { open, onClose: handleClose, chapter } = props;

  const confirmDelete = () => {
    dispatch(deleteEntity(chapter.id));
  };

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && handleClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <Translate contentKey="entity.delete.title">
              Confirm delete operation
            </Translate>
          </DialogTitle>
        </DialogHeader>
        <p className="text-body text-[var(--color-mockup-text-mid)]">
          <Translate
            contentKey="edocendoApp.edoChapter.delete.question"
            interpolate={{ nome: chapter?.title }}
          >
            Are you sure you want to delete this EdoCapitolo?
          </Translate>
        </p>
        <DialogFooter className="gap-2 pt-4">
          <Button variant="outline" onClick={handleClose}>
            <Translate contentKey="entity.action.cancel">Cancel</Translate>
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            <Translate contentKey="entity.action.delete">Delete</Translate>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteChapter;
